import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AuthService from '../../services/AuthService';

const Login = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const onFinish = async (values) => {
        try {
            const companyCode = values.company && typeof values.company === 'string'
                ? values.company.trim()
                : (values.company || null);

            const response = await AuthService.login({
                UserName: values.username,
                Secret: values.password,
                CompanyCode: companyCode
            });
            if (response.status === 200) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('x-access-token', response.data.token);
                localStorage.setItem('userDetails', JSON.stringify(response.data.user));
                message.success('Giriş başarılı!');
                navigate('/dashboard');
            } else {
                message.error('Kullanıcı adı veya şifre yanlış.');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.';
            message.error(errorMessage);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="flex flex-col items-center justify-center mb-8">
                    <div className="flex items-center justify-center gap-3 mb-6">
                        <div className="logo-image h-8"></div>
                        <h2 className="text-[1.75rem] font-bold text-[#ff2c3c] m-0 tracking-wide logo-text">
                            Bulut
                        </h2>
                    </div>
                    <p className="text-gray-600 font-medium">Lütfen hesabınıza giriş yapın</p>
                </div>

                <Form
                    form={form}
                    name="login"
                    onFinish={onFinish}
                    layout="vertical"
                    size="large"
                >
                    <Form.Item
                        name="company"
                        rules={[]}
                    >
                        <Input
                            placeholder="Şirket Kodu"
                            className="rounded-lg font-medium"
                        />
                    </Form.Item>

                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: 'Lütfen kullanıcı adınızı girin!' }]}
                    >
                        <Input
                            prefix={<UserOutlined className="text-gray-400" />}
                            placeholder="Kullanıcı Adı"
                            className="rounded-lg font-medium"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Lütfen şifrenizi girin!' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined className="text-gray-400" />}
                            placeholder="Şifre"
                            className="rounded-lg font-medium"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            className="w-full !bg-brand hover:!bg-brand-light active:!bg-brand-dark rounded-lg h-12 text-lg font-semibold tracking-wide"
                        >
                            Giriş Yap
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default Login;